var React = require('react');

function CircleIconArrowSmallInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(2 2)","strokeWidth":"2","strokeLinecap":"round","fillRule":"evenodd"},[React.createElement("circle",{"className":"circle","cx":"12","cy":"12","r":"12","key":0}),React.createElement("path",{"className":"icon","d":"M7 12h10m.694 0L13 7m4.694 5L13 17","key":1})]));
}

CircleIconArrowSmallInline.defaultProps = {"viewBox":"0 0 28 28"};

module.exports = CircleIconArrowSmallInline;

CircleIconArrowSmallInline.default = CircleIconArrowSmallInline;
